import React, { Component } from 'react';
import styles from './style.css';
import Util from '../utilPc/';
import jsonp from '../base/jsonp';

const pcVideoUtil = new Util();

class Recommend extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isRender: true,
            showItem: false,
            leftable: true,
            rightable: true,
            containerLeftHover: false,
            containerRightHover: false,
            recommend: [],
        };
    }
    async componentDidMount() {
        await this.getData();
    }
    getData = async () => {
        try {
            let num = 0;
            let callbackName = `callbackRecommend_${num}`;

            while (window[callbackName]) {
                num++;
                callbackName = `callbackRecommend_${num}`;
            }

            const data = await jsonp(
                `//tv.ifeng.com/common/video-player-final-recommendation_${callbackName}/getByKey.json`,
                {
                    jsonpCallback: callbackName,
                    cache: false,
                },
            );

            this.setState({
                recommend: data,
            });
        } catch (e) {
            console.error('recommend接口报错', e);
        }
    };

    clearPicUrl = url => {
        if (!url) {
            return url;
        }

        if (url.indexOf('http://') === 0) {
            url = url.replace('http://', '//');
        } else if (url.indexOf('https://') === 0) {
            url = url.replace('https://', '//');
        }

        if (url.indexOf('http://') > 0) {
            url = url.replace('http://', '');
        } else if (url.indexOf('https://') > 0) {
            url = url.replace('https://', '');
        }

        return url;
    };

    /**
     * 初始化component
     */
    getChidren() {
        const data = this.state.recommend;

        const children = data.map(item => (
            <li key={item.GUID}>
                <div>
                    <a href={item.pageUrl}>
                        <img src={this.clearPicUrl(item.stills)} />
                        <i />
                        <span className="time">{pcVideoUtil.formatTime(item.duration)}</span>
                        <em>{item.title}</em>
                    </a>
                </div>
            </li>
        ));

        return <ul id="js_recommend_list">{children}</ul>;
    }
    turnLeft = () => {
        this.turn('left');
    };
    turnRight = () => {
        this.turn('right');
    };
    turn = type => {
        // const containerRight = document.getElementsByClassName('containerRight')[0];
        // const containerLeft = document.getElementsByClassName('containerLeft')[0];

        /**
         * 后推荐宽度
         */
        const recommendWidth = parseInt(pcVideoUtil.getStyle(document.getElementById('js_recommend_container')).width);
        const recommendMax = 180 * pcVideoUtil.delNodes(document.getElementById('js_recommend_list')).childNodes.length;

        const change = type === 'right' ? -1 : 1;
        const recommendList = document.getElementById('js_recommend_list');
        const _curLeft = parseInt(pcVideoUtil.getStyle(recommendList).left);
        let changeLeft = _curLeft + change * recommendWidth;

        if (type === 'left') {
            if (_curLeft === 0) {
                return;
            }
            changeLeft = Math.min(changeLeft, 0);
        } else if (type === 'right') {
            changeLeft = Math.max(changeLeft, -(recommendMax - recommendWidth));
        }

        recommendList.style.left = `${changeLeft}px`;

        this.setState({
            containerLeftHover: true,
            containerRightHover: true,
        });

        if (changeLeft === 0) {
            this.setState({
                containerLeftHover: false,
            });
        } else if (changeLeft === -(recommendMax - recommendWidth)) {
            this.setState({
                containerRightHover: false,
            });
        }
    };
    show = () => {
        this.setState({
            showItem: true,
        });
    };
    hide = () => {
        this.setState({
            showItem: false,
        });
    };
    destroy = () => {
        this.setState({
            isRender: false,
        });
    };
    render() {
        const children = this.getChidren();
        const { showItem, leftable, rightable, containerLeftHover, containerRightHover, isRender } = this.state;

        return isRender ? (
            <div
                id="js_video_recommend"
                className={styles.videorecommend}
                style={{ display: showItem ? 'block' : 'none' }}>
                <div className={styles.videoRecommendLayout}>
                    <div className={styles.videoRecommendPosition}>
                        <div className={containerLeftHover ? styles.containerLeftHover : styles.containerLeft}>
                            <div
                                className={leftable ? styles.recommendLeft : styles.recommendLeftDisabled}
                                onClick={this.turnLeft}
                                id="js_recommend_pageL"
                            />
                        </div>
                        <div className={containerRightHover ? styles.containerRightHover : styles.containerRight}>
                            <div
                                className={rightable ? styles.recommendRight : styles.recommendRightDisabled}
                                onClick={this.turnRight}
                                id="js_recommend_pageR"
                            />
                        </div>
                        <div className={styles.containerList} id="js_recommend_container">
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        ) : null;
    }
}

export default Recommend;
